import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createContext } from 'react';

export const UserContext = createContext({});
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [userStorage] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const navigate = useNavigate();

  // Initialize user state from localStorage
  useEffect(() => {
    if (userStorage != null) {
      setUser(userStorage);
    }
  }, [userStorage]);

  // Save user to localStorage on change
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }, [user]);

  // Detect logout across tabs and redirect to "/"
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'user' && event.newValue == null) {
        navigate('/');
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [navigate]);

  const providerValue = useMemo(() => ({ user, setUser }), [user, setUser]);

  return (
    <UserContext.Provider value={providerValue}>
      {children}
    </UserContext.Provider>
  );
};
